import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const getProjectFilePermissions = async (projectId) => {
  const apiPath = `projects/${projectId}/image-permissions`;

  // const apiPath = `projects/${projectId}/file-permissions-all?fromDate=${params.fromDate}&toDate=${params.toDate}&type=${params.type}`

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
